import React from "react";

export const MainPageTabIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 11C19.1046 11 20 9.88071 20 8.5C20 7.11929 19.1046 6 18 6"
        stroke="black"
        strokeWidth="1.5"
      />
      <path d="M3 6H18M18.0002 11H3" stroke="black" strokeWidth="1.5" />
      <path
        d="M3 11C4.10457 11 5 9.88071 5 8.5C5 7.11929 4.10457 6 3 6"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M18 20C19.1046 20 20 18.8807 20 17.5C20 16.1193 19.1046 15 18 15"
        stroke="black"
        strokeWidth="1.5"
      />
      <path d="M3 15H18M18.0002 20H3" stroke="black" strokeWidth="1.5" />
      <path
        d="M3 20C4.10457 20 5 18.8807 5 17.5C5 16.1193 4.10457 15 3 15"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  );
};
